<template>
    <div class="sign-up-resume">
        <div class="sign-up-resume__header">
            <h2 class="sign-up-resume__header-title">
                Resumo do pedido
            </h2>
        </div>

        <div class="sign-up-resume__content">
            <ul>
                <li v-if="computedName" class="sign-up-resume__content-item">
          <span class="sign-up-resume__content-item-label">
            Nome da assinatura
          </span>
                    <span class="sign-up-resume__content-item-text">
            {{ computedName }}
          </span>
                </li>

                <li v-if="computedType" class="sign-up-resume__content-item">
          <span class="sign-up-resume__content-item-label">
            Tipo da assinatura
          </span>
                    <span class="sign-up-resume__content-item-text">
            {{ computedType }}
          </span>
                </li>

                <li v-if="computedPayment" class="sign-up-resume__content-item">
          <span class="sign-up-resume__content-item-label">
            Forma de pagamento
          </span>
                    <span class="sign-up-resume__content-item-text">
            {{ computedPayment }}
          </span>
                </li>
            </ul>

            <template v-if="!simple">
                <vs-divider class="sign-up-resume__content-divider"/>

                <ul class="sign-up-resume__content-services">
                    <li v-for="(service, idx) in computedServices" :key="`${idx}${service}`"
                        class="sign-up-resume__content-services-item">
                        <AppIcon icon="mdi-check-circle" size="large" class="sign-up-resume__content-services-icon"/>
                        <span class="sign-up-resume__content-services-label">{{ service }}</span>
                    </li>
                </ul>
            </template>

            <template v-if="computedPeriod">
                <vs-divider class="sign-up-resume__content-divider"/>

                <div class="sign-up-resume__content-item">
          <span class="sign-up-resume__content-item-label">
            Valor
          </span>
                    <span class="sign-up-resume__content-item-text">
            <span class="sign-up-resume__content-item-value">
              {{ computedValue | monetary }}
            </span>
            <span class="sign-up-resume__content-item-period">
              por {{ computedPeriod }}
            </span>
          </span>
                </div>
            </template>

            <p class="sign-up-resume__content-legend">
                *Valor {{ computedPeriodRecurrency }} da assinatura com vínculo anual. Sua assinatura será renovada
                automaticamente.
            </p>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'

import paymentsList from '@/constants/payments'
import AppIcon from '@/components/AppIcon'

export default defineComponent({
    name: 'SignUpResume',

    components: {
        AppIcon
    },

    props: {
        payment: {
            type: String,
            default: 'cartao',
            required: true
        },
        plan: {
            type: Object,
            required: true
        },
        simple: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        computedName() {
            const types = ['familiar', 'individual']
            const chkHyphen = this.plan.name.indexOf(' - ') >= 0
            const splittedName = this.plan.name.split(chkHyphen ? ' - ' : ' ')
            const chkTypes = types.filter((type) => this.plan.name.toLowerCase().includes(type))

            if (chkHyphen) {
                return splittedName.length < 3 ? splittedName[0] : splittedName[1]
            }
            if (chkTypes.length) {
                return splittedName.filter((name) => !chkTypes.includes(name.toLowerCase())).join(' ')
            }
            return this.plan.name
        },
        computedType() {
            return this.plan.additionalLifeMax > 0 ? 'Familiar' : 'Individual'
        },
        computedPayment() {
            return !this.plan.isFreemium
                ? paymentsList.find(payment => payment.slug === this.payment).name
                : ''
        },
        computedPeriod() {
            const period = ['mes', 'mês', 'mensal', 'mensais']

            return period.includes(this.plan.period) ? 'mês' : 'ano'
        },
        computedPeriodRecurrency() {
            const period = ['mes', 'mês', 'mensal', 'mensais']

            return period.includes(this.plan.period) ? 'mensal' : 'anual'
        },
        computedValue() {
            return this.plan.freetrial && this.simple ? 0 : this.plan.planValue
        },
        computedServices() {
            return this.plan.planServices.map((service) => service.name)
        },
    }
})
</script>

<style lang="scss" scoped>
.sign-up-resume {
    &__header {
        &-title {
            font-size: 1.5rem;
            line-height: 1.75rem;
        }
    }

    &__content {
        margin-top: 1.5rem;

        &-item {
            align-items: flex-start;
            display: flex;
            justify-content: space-between;

            &:not(:first-of-type) {
                margin-top: .5rem;
            }

            &-label {
                letter-spacing: 0px;
            }

            &-text {
                letter-spacing: 0px;
                font-weight: 600;
                text-align: right;
            }

            &-value {
                color: rgb(var(--vs-primary)) !important;
                font-size: 1.5rem;

                @media #{$lg-and-up} {
                    font-size: 1.75rem;
                }
            }

            &-period {
                font-weight: normal !important;
            }
        }

        &-legend {
            font-size: .875rem;
            margin-top: 2rem;
        }

        &-services {
            &-item {
                align-items: flex-start;
                display: flex;

                &:not(:first-child) {
                    margin-top: .5rem;
                }
            }

            &-icon {
                height: 1.5rem;
                width: 1.5rem;
            }

            &-label {
                font-size: 1rem;
                font-weight: 400;
            }
        }

        &-divider {
            &::v-deep {
                .vs-divider-border {
                    border: 1px solid #00000080;
                }
            }
        }
    }
}
</style>
